module.exports = __webpack_public_path__ + "static/media/signalLong.c1c61c2f.wav";